import { GroupStyle } from '../enums'
import { FormFieldDefinition } from './form-field-definition'
import { TabDirection } from './tab-direction'
import { UIElementDefinition } from './ui-element-definition'

export enum Separator {
  None = 10,
  Top = 20,
  Bottom = 30,
  Both = 40,
}
export enum EndToEndSeparator {
  None = 10,
  Top = 20,
  Bottom = 30,
  Both = 40,
}

export interface FormGroupDefinition extends UIElementDefinition {
  idml: string
  description: string
  name: string
  layout: FormFieldDefinition[]
  columns: number
  tabDirection: TabDirection
  hideGroupHeader: boolean
  separator: Separator
  endToEndSeparator: EndToEndSeparator
  groupStyle: GroupStyle
  customUI: string
  entityName: string
  formName: string
  showMandatory: boolean
  subtitle: {
    idml: string
    description: string
  }
}
